/**
 * Import Lib & assets
 */

import React, { useState, useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */
import { Content__error } from "components/content/content";
import { Form__radio, Form__list, Form__checkbox, Form__radio__image } from "components/form/form";

/**
 * import context
 */
import { AppContext } from "context/appContext";
import { ContentContext } from "context/contentContext";

/**
 * styled components
 */

const Question = styled.div`
  ${t.mixins.flex({ direction: "column", align: "center" })}
  padding: 48px 0;
  border-top: 1px solid ${t.color.lightGrey};

  ${t.mixins.sm(`
    padding: 35px 42px;
    padding: 35px 18px;
  `)}

  &:first-child {
    border-width: 0;
  }
`;

const Title = styled.p`
  margin-bottom: 24px;
  ${t.mixins.rem(26, 20)}
  text-align: center;
  font-weight: ${t.font.regular};
  font-family: ${t.font.primary};
  color: ${t.color.primary};

  ${t.mixins.sm(`
    margin-bottom: ${t.grid.space2};
    ${t.mixins.rem(20, 22)}
  `)}
`;

const Subtitle = styled.p`
  margin-bottom: 34px;
  ${t.mixins.rem(18, 19)}
  text-align: center;
  font-weight: ${t.font.bold};
  font-family: ${t.font.primary};
  color: ${t.color.black};

  ${t.mixins.sm(`
  margin-bottom: 19px;
    ${t.mixins.rem(13, 12)}
  `)}
`;

const Error = styled(Content__error)`
  transform: translateY(120px);
`;

/**
 * question component is..
 */

const components = {
  radio: Form__radio,
  radio_image: Form__radio__image,
  list: Form__list,
  checkbox: Form__checkbox,
};

const Form__question = ({ question }) => {
  const { c } = useContext(ContentContext);
  const Answers = components[question.type];
  const { title, subtitle, answers, id } = question;
  const { setAnswer, userAnswers, getFilteredProducts } = useContext(AppContext);
  const filled = userAnswers[id];
  const error = getFilteredProducts().length === 0;
  return (
    <Question>
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      <Answers
        answers={answers}
        updateValue={answer => {
          setAnswer(id, answer);
        }}
        filled={filled}
        error={error}
      />
      {filled && userAnswers[id].length !== 0 && error && (
        <Error content={c('home.products.none')} />
      )}
    </Question>
  );
};
export default Form__question;

Form__question.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
  /**
      Object containing question specs
      */
  question: PropTypes.shape({}),
};

Form__question.defaultProps = {
  style: {},
  question: {},
};

/*
    import Form__question from 'components/form/question/form__question'
    <Form__question />
  */
